var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 15.3585H10.8327L7.12434 17.8252C6.57434 18.1918 5.83268 17.8002 5.83268 17.1335V15.3585C3.33268 15.3585 1.66602 13.6919 1.66602 11.1919V6.19181C1.66602 3.69181 3.33268 2.02515 5.83268 2.02515H14.166C16.666 2.02515 18.3327 3.69181 18.3327 6.19181V11.1919C18.3327 13.6919 16.666 15.3585 14.166 15.3585Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 9.4668V9.29183C10.0005 8.72516 10.3505 8.42515 10.7005 8.18348C11.0422 7.95015 11.3838 7.65016 11.3838 7.10016C11.3838 6.33349 10.7672 5.7168 10.0005 5.7168C9.23383 5.7168 8.61719 6.33349 8.61719 7.10016",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9969 11.4585H10.0044",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.c937efc5909da0e08c57a54549faba8a.svg";
export { ForwardRef as ReactComponent };